import { useContext } from 'react';
import { TeamPermissionsContext } from 'components/teams/TeamPermissionsProvider';
const useTeamPermissions = () => useContext(TeamPermissionsContext);
export default useTeamPermissions;